export const enum MenusDisplayOptions {
  All = 'all',
  Specific = 'specific',
}
